import { FC } from 'react';

export interface IMoodessBarProps {
  label?: string;
  isMax?: boolean;
  value: number;
  showDate: boolean;
}

const BarColors: string[] = ['', '#FF4B55', '#FF8C00', '#FFC53A', '#6FCF97', '#357D45'];
const BarHeights: number[] = [0, 10, 38, 66, 94, 122];

export const MoodProgressBar: FC<IMoodessBarProps> = ({ label, isMax, value, showDate }) => {
  const barHeight = BarHeights[value];
  const barYPos = 136 - barHeight;
  return (
    <>
      <rect x="0" y="0" width="20" height="1" className="border" />
      {isMax ? (
        <path
          className="star"
          d="M12 0L15.174 7.63131L23.4127 8.2918L17.1357 13.6687L19.0534 21.7082L12 17.4L4.94658 21.7082L6.86429 13.6687L0.587322 8.2918L8.82596 7.63131L12 0Z"
        />
      ) : null}
      <rect x="8" y={barYPos} width="15" height={barHeight} className="bar" fill={BarColors[value]} />
      <rect x="0" y="136" width="20" height="1" className="border" />
      {showDate && label ? (
        <text x="15" y="150" className="label">
          {label}
        </text>
      ) : null}
    </>
  );
};

export default MoodProgressBar;
